import { render } from "./sDetail.vue?vue&type=template&id=4c52a7fc"
import script from "./sDetail.vue?vue&type=script&lang=js"
export * from "./sDetail.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./sDetail.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(script)


import exportComponent from "D:\\workspace\\zh-frontend\\microfront-main\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__